import { createContext, useEffect, useState } from 'react';
import type { ReactNode } from 'react';
import { SimpleDataCacheService } from '@/lib/utils/simple-data-cache-service';
import { sortHistoricalEventsByBook } from './historical-events-by-book-data-service';

interface HistoricalEventsByBookDataContextType {
  historicalEventsByBook: HistoricalEventsByBook[];
  getHistoricalEventsByBookByBook: (book: string) => HistoricalEventsByBook | undefined;
}

export const HistoricalEventsByBookDataContext = createContext<HistoricalEventsByBookDataContextType | undefined>(undefined);

interface HistoricalEventsByBookDataProviderProps {
  children: ReactNode;
  historicalEventsByBook: HistoricalEventsByBook[];
}

export function HistoricalEventsByBookDataProvider({ children, historicalEventsByBook: initialData }: HistoricalEventsByBookDataProviderProps) {
  const [cacheService] = useState(() =>
    new SimpleDataCacheService<HistoricalEventsByBook>(
      initialData,
      sortHistoricalEventsByBook
    )
  );

  // Track the current items in state so the component re-renders when they change
  const [historicalEventsByBook, setHistoricalEventsByBook] = useState<HistoricalEventsByBook[]>(initialData);

  useEffect(() => {
    cacheService.setNewItems(initialData);
    setHistoricalEventsByBook(cacheService.getItems());
  }, [initialData, cacheService]);

  const getHistoricalEventsByBookByBook = (book: string): HistoricalEventsByBook | undefined => {
    return historicalEventsByBook.find(item => item.book === book);
  };

  return (
    <HistoricalEventsByBookDataContext.Provider
      value={{
        historicalEventsByBook,
        getHistoricalEventsByBookByBook
      }}
    >
      {children}
    </HistoricalEventsByBookDataContext.Provider>
  );
}

